import { FC, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { ListingPrice } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";
import { ResourceListingPriceDateSelect } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/listing-price/ResourceListingPriceDateSelect";

interface ResourceDetailsListingPriceProps {
  listing_price?: ListingPrice;
}

export const ResourceDetailsListingPrice: FC<
  ResourceDetailsListingPriceProps
> = ({ listing_price }) => {
  const [frequency, setFrequency] = useState<string>("monthly");

  if (!listing_price) {
    return "N/A";
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <ResourceListingPriceDateSelect
        value={frequency}
        onChange={setFrequency}
      />
      <Typography variant="body2">
        {money(listing_price?.[frequency as keyof ListingPrice])}
      </Typography>
    </Stack>
  );
};
